export interface SeriesEntry {
  year: string;
  title: string;
  director: string;
  crew: string;
  badge: string;
  summary: string;
}

export const seriesEntries: SeriesEntry[] = [
  {
    year: '1993',
    title: '蜜桃成熟时',
    director: '张肇麟',
    crew: '监制 高志森 · 主演 李丽珍、潘震伟、霍瑞华',
    badge: '系列开山之作',
    summary:
      '系列的第一部，也是知名度最高的一部。以富家女阿珍的出走与远行串联全片，确立了「都市情欲 + 女性成长」的基调，是 1990 年代香港同类题材的代表作之一。',
  },
  {
    year: '1997',
    title: '蜜桃成熟时 1997',
    director: '钱文锜',
    crew: '主演 舒淇、徐锦江、苑琼丹、钟真等',
    badge: '系列延续',
    summary:
      '被视为《蜜桃成熟时》的续集，故事另起炉灶：围绕八岁女孩徐蜜桃渴望长大，一夜之间变成成人的奇幻设定展开，用更夸张的喜剧手法讲述成长与情感启蒙。',
  },
  {
    year: '2011',
    title: '蜜桃成熟时 33D',
    director: '钱文锜',
    crew: '名威影业出品 · 演出 陈俊言、吴晴晴等',
    badge: '系列新篇',
    summary:
      '相隔十余年后的系列新作，在原本的都市题材中加入科幻元素，讲述来自未来的美少女来到地球寻找「完美基因」的故事。片名中的「33D」是带有商业噱头的标记。',
  },
];